{
  "processing": "인증 처리 중...",
  "loadingIframe": "신원 확인을 불러오는 중...",
  "issueTitle": "신원 확인 문제",
  "notConfigured": "이 창고에는 신원 확인이 올바르게 구성되어 있지 않습니다.",
  "notSuccessful": "신원 확인에 실패했습니다. 다시 시도하거나 창고에 문의하세요.",
  "couldNotCompleteProceed": "신원 확인을 완료할 수 없지만 체크인을 계속할 수 있습니다.",
  "processFailed": "신원 확인 처리에 실패했습니다. 다시 시도해 주세요.",
  "processingFailedProceed": "신원 확인 처리에 실패했지만 체크인을 계속할 수 있습니다.",
  "genericError": "신원 확인 중 오류가 발생했습니다. 다시 시도해 주세요.",
  "issueProceed": "신원 확인 중 문제가 발생했지만 체크인을 계속할 수 있습니다.",
  "requiredTryAgain": "체크인을 완료하려면 신원 확인이 필요합니다. 다시 시도해 주세요.",
  "checkInFailedTitle": "체크인할 수 없습니다",
  "checkInFailedMessage": "신분증을 확인할 수 없습니다"
}
